import React from 'react';
import { Table } from 'semantic-ui-react';
import { FILETYPE_BASICWISH, FILETYPE_CHARTER, FILETYPE_SCENARIO } from '../../../globals';
import FileTableRow from './FileTableRow';

const FileTable = ({data, fileType, onlyUser}) => {
    const isScenario = (fileType === FILETYPE_SCENARIO);
    const canDelete = isScenario && onlyUser;
    const tableHeader = (
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>User</Table.HeaderCell>
                <Table.HeaderCell>Description</Table.HeaderCell>
                <Table.HeaderCell>Timestamp</Table.HeaderCell>
                <Table.HeaderCell collapsing>Result</Table.HeaderCell>
                {isScenario && <Table.HeaderCell collapsing>Detailed</Table.HeaderCell>}
                {isScenario && <Table.HeaderCell collapsing>Final</Table.HeaderCell>}
                {canDelete  && <Table.HeaderCell collapsing></Table.HeaderCell>}
            </Table.Row>
        </Table.Header>
    )

    const rows = data.map((upload) => (
                    <FileTableRow 
                        uploadId={upload.key}
                        isScenario={isScenario}
                        canDelete={canDelete}
                        {...upload}
                    />
                ));

    return (
        <Table celled unstackable>
            {tableHeader}
            <Table.Body>
                {rows}
            </Table.Body>
        </Table>
    );
}

export default FileTable;


// WEBPACK FOOTER //
// ./src/pages/Home/FileTable/FileTable.js